//London and whipsnade colours are placeholders
//TODO please change them
import { colors as baseColors } from '@/theme/lib';

export const colors = {
  zsl: {
    primary: baseColors.seagrass,
    secondary: baseColors.zooBg,
    tertiary: baseColors.parakeet,
    eyebrow: baseColors.honeyBee,
    infoLabel: baseColors.honeyBee,
    background: baseColors.panther,
    header: {
      bg: baseColors.white,
      text: baseColors.white,
      textDesktop: baseColors.black,
      smallNavLink: {
        text: baseColors.parakeet,
        textDesktop: baseColors.black,
        bg: baseColors.zooBg,
        bgDesktop: baseColors.zooBg,
      },
    },
    testimonial: {
      title: baseColors.zooBg,
      quote: {
        text: baseColors.white,
        quoteIcon: baseColors.gecko,
        background: baseColors.seagrass,
      },
      slider: {
        mainTitleText: baseColors.zooBg,
        paginationBulletActive: baseColors.parakeet,
        paginationBullet: baseColors.parakeet,
        paginationArrowCircle: baseColors.seagrass,
        paginationArrowPath: baseColors.parakeet,
      },
    },
    button: {
      primary: {
        text: baseColors.white,
        bg: baseColors.seagrass,
        border: 'transparent',
        focusBorder: baseColors.parakeet,
        hoverBorder: 'transparent',
        hoverBackground: baseColors.parakeet,
        hoverText: baseColors.panther,
      },
      secondary: {
        text: baseColors.seagrass,
        bg: baseColors.white,
        border: baseColors.seagrass,
        focusBorder: baseColors.parakeet,
        hoverBorder: baseColors.seagrass,
        hoverBackground: baseColors.parakeet,
        hoverText: baseColors.panther,
      },
      download: {
        text: baseColors.seagrass,
        bg: baseColors.white,
        border: baseColors.seagrass,
        focusBorder: baseColors.parakeet,
        icon: baseColors.seagrass,
        file: 'london',
      },
      news: {
        text: baseColors.seagrass,
        bg: baseColors.white,
        border: baseColors.white,
        hoverText: baseColors.panther,
        hoverBackground: baseColors.parakeet,
        focusBorder: baseColors.parakeet,
      },
      pill: {
        text: baseColors.white,
        bg: baseColors.seagrass,
        border: 'transparent',
        focusBorder: baseColors.parakeet,
      },
      social: {
        bg: baseColors.parakeet,
        border: baseColors.parakeet,
        focusBackground: baseColors.white,
        focusBorder: baseColors.seagrass,
      },
      back: {
        text: baseColors.white,
        bg: baseColors.seagrass,
        border: baseColors.panther,
        focusBorder: baseColors.honeyBee,
        focusBackground: baseColors.seagrass,
      },
    },
    cards: {
      infographic: {
        color: baseColors.panther,
        background: baseColors.parakeet,
      },
      generic: {
        link: baseColors.parakeet,
        eyebrow: baseColors.honeyBee,
        paragraph: baseColors.zooBg,
        imageBackground: baseColors.parakeet,
        label: baseColors.honeyBee,
      },
      featureCardTwoThreeSection: {
        background: baseColors.white,
        pattern: baseColors.white,
        primaryButtonBg: baseColors.seagrass,
        primaryButtonText: baseColors.white,
        secondaryButtonHoverBorderColor: baseColors.parakeet,
        primaryButtonHoverBgColor: baseColors.parakeet,
        secondaryButtonBg: baseColors.white,
        secondaryButtonText: baseColors.seagrass,
        mainTitle: baseColors.panther,
        cardTitle: baseColors.panther,
        cardEyebrow: baseColors.parakeet,
        cardParagraph: baseColors.panther,
      },
      event: {
        text: baseColors.white,
        border: baseColors.parakeet,
        background: 'transparent',
        ctaText: baseColors.panther,
        ctaBg: baseColors.parakeet,
      },
    },
    carousel: {
      mainTitleText: baseColors.zooBg,
      paginationBulletActive: baseColors.parakeet,
      paginationBullet: baseColors.seagrassDark,
      paginationOverviewAnchorBg: baseColors.seagrass,
      paginationOverviewAnchorText: baseColors.white,
      paginationArrowCircle: baseColors.honeyBee,
      paginationArrowCircleBorder: baseColors.honeyBee,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.black,
    },
    imageGalleryPagination: {
      paginationArrowCircle: baseColors.honeyBee,
      paginationArrowCircleBorder: baseColors.honeyBee,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.black,
    },
    promo: {
      withBackground: {
        text: baseColors.white,
        button: baseColors.white,
      },
      withoutBackground: {
        text: baseColors.white,
        button: baseColors.seagrass,
      },
    },
    donate: {
      background: baseColors.seagrass,
      text: baseColors.white,
      link: {
        background: baseColors.parakeet,
        text: baseColors.panther,
      },
      button: {
        wrapperBackground: baseColors.panther,
        background: baseColors.panther,
        text: baseColors.white,
        activeBackground: baseColors.parakeet,
        activeText: baseColors.panther,
        hoverText: baseColors.parakeet,
      },
    },
    donateHeaderButton: {
      background: baseColors.parakeet,
      text: baseColors.panther,
      activeBackground: baseColors.white,
      activeText: baseColors.seagrass,
      hoverBackground: baseColors.panther,
      hoverText: baseColors.parakeet,
      border: baseColors.panther,
      iconColor: baseColors.seagrass,
    },
    newsletter: {
      bg: baseColors.seagrass,
    },
    featureBackground: baseColors.seagrass,
    caption: baseColors.white,
    heading: baseColors.zooBg,
    text: baseColors.zooBg,
    tableHeading: baseColors.white,
    link: baseColors.parakeet,
    accordionTabColour: baseColors.white,
    accordionIconColour: baseColors.parakeet,
    accordionTabBgr: baseColors.seagrass,
    accordionTabBorderColour: baseColors.gecko,
    accordionTabFocusColour: baseColors.parakeet,
    accordionTabLink: baseColors.parakeet,
    footerBgr: baseColors.seagrass,
    footerNewsletterBlockBtnBgr: baseColors.seagrass,
    footerNewsletterBlockBtnBgrHover: baseColors.parakeet,
    footerNewsletterBlockBtnColor: baseColors.white,
    footerNewsletterBlockBtnColorHover: baseColors.black,
    footerNewsletterBlockTextColor: baseColors.seagrass,
    dateUnderlineColor: baseColors.parakeet,
    membership: {
      type: {
        goldColor: baseColors.honeyBee,
        silverColor: baseColors.silver,
        nameColor: baseColors.white,
        descriptionColor: baseColors.honeyBee,
        borderColor: baseColors.parakeet,
      },
      price: {
        backgroundColor: baseColors.seagrass,
        pawsIconColor: {
          primary: baseColors.black,
          secondary: baseColors.white,
        },
      },
    },
    eventListing: {
      backgroundColor: baseColors.seagrass,
      textColor: baseColors.white,
    },
  },
  london: {
    primary: baseColors.gecko,
    secondary: baseColors.zooFont,
    tertiary: baseColors.salmon,
    eyebrow: baseColors.seagrass,
    infoLabel: baseColors.black,
    background: baseColors.londonBg,
    header: {
      bg: baseColors.white,
      text: baseColors.black,
      textDesktop: baseColors.black,
      smallNavLink: {
        text: baseColors.tiger,
        textDesktop: baseColors.black,
        bg: baseColors.zooBg,
        bgDesktop: baseColors.zooBg,
      },
    },
    testimonial: {
      title: baseColors.zooFont,
      quote: {
        text: baseColors.white,
        quoteIcon: baseColors.honeyBee,
        background: baseColors.seagrass,
      },
      slider: {
        mainTitleText: baseColors.zooFont,
        paginationBulletActive: baseColors.gecko,
        paginationBullet: baseColors.gecko,
        paginationArrowCircle: baseColors.honeyBee,
        paginationArrowPath: baseColors.black,
      },
    },
    button: {
      primary: {
        text: baseColors.black,
        bg: baseColors.gecko,
        border: 'transparent',
        focusBorder: baseColors.honeyBee,
        hoverBorder: 'transparent',
        hoverBackground: baseColors.honeyBee,
        hoverText: baseColors.black,
      },
      secondary: {
        text: baseColors.black,
        bg: baseColors.white,
        border: baseColors.gecko,
        focusBorder: baseColors.honeyBee,
        hoverBorder: baseColors.gecko,
        hoverBackground: baseColors.honeyBee,
        hoverText: baseColors.black,
      },
      download: {
        text: baseColors.black,
        bg: baseColors.gecko,
        border: 'transparent',
        focusBorder: baseColors.honeyBee,
        icon: baseColors.white,
        file: 'london',
      },
      news: {
        text: baseColors.black,
        bg: baseColors.honeyBee,
        border: baseColors.honeyBee,
        hoverText: baseColors.black,
        hoverBackground: baseColors.white,
        focusBorder: baseColors.white,
      },
      pill: {
        text: baseColors.black,
        bg: baseColors.honeyBee,
        border: baseColors.honeyBee,
        focusBorder: baseColors.gecko,
      },
      social: {
        bg: baseColors.gecko,
        border: baseColors.gecko,
        focusBackground: baseColors.honeyBee,
        focusBorder: baseColors.honeyBee,
      },
      back: {
        text: baseColors.panther,
        bg: baseColors.white,
        border: baseColors.panther,
        focusBorder: baseColors.panther,
        focusBackground: baseColors.white,
      },
    },
    cards: {
      infographic: {
        color: baseColors.zooFont,
        background: baseColors.gecko,
      },
      generic: {
        link: baseColors.seagrass,
        eyebrow: baseColors.zooFont,
        paragraph: baseColors.zooFont,
        imageBackground: baseColors.seagrass,
        label: baseColors.seagrass,
      },
      featureCardTwoThreeSection: {
        background: baseColors.seagrass,
        pattern: baseColors.honeyBee,
        primaryButtonBg: baseColors.honeyBee,
        primaryButtonText: baseColors.zooFont,
        secondaryButtonHoverBorderColor: baseColors.honeyBee,
        primaryButtonHoverBgColor: baseColors.white,
        secondaryButtonBg: baseColors.white,
        secondaryButtonText: baseColors.zooFont,
        mainTitle: baseColors.zooBg,
        cardTitle: baseColors.white,
        cardEyebrow: baseColors.white,
        cardParagraph: baseColors.white,
      },
      event: {
        text: baseColors.zooFont,
        border: baseColors.parakeet,
        background: baseColors.londonBg,
        ctaText: baseColors.black,
        ctaBg: baseColors.gecko,
      },
    },
    carousel: {
      mainTitleText: baseColors.zooFont,
      paginationBulletActive: baseColors.seagrass,
      paginationBullet: baseColors.seagrass,
      paginationOverviewAnchorBg: baseColors.seagrass,
      paginationOverviewAnchorText: baseColors.zooBg,
      paginationArrowCircle: baseColors.honeyBee,
      paginationArrowCircleBorder: baseColors.seagrass,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.black,
    },
    imageGalleryPagination: {
      paginationArrowCircle: baseColors.honeyBee,
      paginationArrowCircleBorder: baseColors.seagrass,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.black,
    },
    promo: {
      withBackground: {
        text: baseColors.white,
        button: baseColors.zooFont,
      },
      withoutBackground: {
        text: baseColors.zooFont,
        button: baseColors.black,
      },
    },
    donate: {
      background: baseColors.gecko,
      text: baseColors.panther,
      link: {
        background: baseColors.honeyBee,
        text: baseColors.panther,
      },
      button: {
        wrapperBackground: baseColors.londonBg,
        background: baseColors.londonBg,
        text: baseColors.panther,
        activeBackground: baseColors.honeyBee,
        activeText: baseColors.panther,
        hoverText: baseColors.black,
      },
    },
    donateHeaderButton: {
      background: baseColors.gecko,
      text: baseColors.panther,
      activeBackground: baseColors.white,
      activeText: baseColors.panther,
      hoverBackground: baseColors.honeyBee,
      hoverText: baseColors.panther,
      border: baseColors.gecko,
      iconColor: baseColors.panther,
    },
    newsletter: {
      bg: baseColors.seagrass,
    },
    featureBackground: baseColors.seagrass,
    caption: baseColors.zooFont,
    heading: baseColors.zooFont,
    text: baseColors.zooFont,
    tableHeading: baseColors.gecko,
    link: baseColors.seagrass,
    accordionTabColour: baseColors.zooFont,
    accordionIconColour: baseColors.zooFont,
    accordionTabBgr: baseColors.gecko,
    accordionTabBorderColour: baseColors.gecko,
    accordionTabFocusColour: baseColors.honeyBee,
    accordionTabLink: baseColors.seagrass,
    footerBgr: baseColors.seagrass,
    footerNewsletterBlockBtnBgr: baseColors.gecko,
    footerNewsletterBlockBtnBgrHover: baseColors.honeyBee,
    footerNewsletterBlockBtnColor: baseColors.panther,
    footerNewsletterBlockBtnColorHover: baseColors.panther,
    footerNewsletterBlockTextColor: baseColors.zooFont,
    dateUnderlineColor: baseColors.gecko,
    membership: {
      type: {
        goldColor: baseColors.honeyBee,
        silverColor: baseColors.silver,
        nameColor: baseColors.black,
        descriptionColor: baseColors.seagrass,
        borderColor: baseColors.gecko,
      },
      price: {
        backgroundColor: baseColors.seagrass,
        pawsIconColor: {
          primary: baseColors.seagrass,
          secondary: baseColors.honeyBee,
        },
      },
    },
    eventListing: {
      backgroundColor: baseColors.seagrass,
      textColor: baseColors.white,
    },
  },
  whipsnade: {
    primary: baseColors.tiger,
    secondary: baseColors.parakeet,
    tertiary: baseColors.black,
    eyebrow: baseColors.redPanda,
    infoLabel: baseColors.black,
    background: baseColors.whipsnadeBg,
    header: {
      bg: baseColors.white,
      text: baseColors.black,
      textDesktop: baseColors.black,
      smallNavLink: {
        text: baseColors.tiger,
        textDesktop: baseColors.black,
        bg: baseColors.zooBg,
        bgDesktop: baseColors.zooBg,
      },
    },
    testimonial: {
      title: baseColors.zooFont,
      quote: {
        text: baseColors.white,
        quoteIcon: baseColors.honeyBee,
        background: baseColors.redPanda,
      },
      slider: {
        mainTitleText: baseColors.zooFont,
        paginationBulletActive: baseColors.tiger,
        paginationBullet: baseColors.tiger,
        paginationArrowCircle: baseColors.honeyBee,
        paginationArrowPath: baseColors.black,
      },
    },
    button: {
      primary: {
        text: baseColors.black,
        bg: baseColors.tiger,
        border: 'transparent',
        focusBorder: baseColors.honeyBee,
        hoverBorder: 'transparent',
        hoverBackground: baseColors.honeyBee,
        hoverText: baseColors.black,
      },
      secondary: {
        text: baseColors.black,
        bg: baseColors.white,
        border: baseColors.tiger,
        focusBorder: baseColors.honeyBee,
        hoverBorder: baseColors.tiger,
        hoverBackground: baseColors.honeyBee,
        hoverText: baseColors.black,
      },
      download: {
        text: baseColors.black,
        bg: baseColors.tiger,
        border: 'transparent',
        focusBorder: baseColors.honeyBee,
        icon: baseColors.white,
        file: 'whipsnade',
      },
      news: {
        text: baseColors.black,
        bg: baseColors.honeyBee,
        border: baseColors.honeyBee,
        hoverText: baseColors.black,
        hoverBackground: baseColors.white,
        focusBorder: baseColors.white,
      },
      pill: {
        text: baseColors.black,
        bg: baseColors.honeyBee,
        border: baseColors.honeyBee,
        focusBorder: baseColors.tiger,
      },
      social: {
        bg: baseColors.tiger,
        border: baseColors.tiger,
        focusBackground: baseColors.honeyBee,
        focusBorder: baseColors.honeyBee,
      },
      back: {
        text: baseColors.panther,
        bg: baseColors.white,
        border: baseColors.panther,
        focusBorder: baseColors.panther,
        focusBackground: baseColors.white,
      },
    },
    cards: {
      infographic: {
        color: baseColors.zooFont,
        background: baseColors.tiger,
      },
      generic: {
        link: baseColors.redPanda,
        eyebrow: baseColors.zooFont,
        paragraph: baseColors.zooFont,
        imageBackground: baseColors.redPanda,
        label: baseColors.redPanda,
      },
      featureCardTwoThreeSection: {
        background: baseColors.redPanda,
        pattern: baseColors.honeyBee,
        primaryButtonBg: baseColors.honeyBee,
        primaryButtonText: baseColors.zooFont,
        secondaryButtonHoverBorderColor: baseColors.honeyBee,
        primaryButtonHoverBgColor: baseColors.white,
        secondaryButtonBg: baseColors.white,
        secondaryButtonText: baseColors.zooFont,
        mainTitle: baseColors.zooBg,
        cardTitle: baseColors.white,
        cardEyebrow: baseColors.white,
        cardParagraph: baseColors.white,
      },
      event: {
        text: baseColors.zooFont,
        border: baseColors.whipsnadeBg,
        background: baseColors.whipsnadeBg,
        ctaText: baseColors.panther,
        ctaBg: baseColors.tiger,
      },
    },
    carousel: {
      mainTitleText: baseColors.zooFont,
      paginationBulletActive: baseColors.tiger,
      paginationBullet: baseColors.tiger,
      paginationOverviewAnchorBg: baseColors.redPanda,
      paginationOverviewAnchorText: baseColors.zooBg,
      paginationArrowCircle: baseColors.honeyBee,
      paginationArrowCircleBorder: baseColors.redPanda,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.zooFont,
    },
    imageGalleryPagination: {
      paginationArrowCircle: baseColors.honeyBee,
      paginationArrowCircleBorder: baseColors.redPanda,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.zooFont,
    },
    promo: {
      withBackground: {
        text: baseColors.white,
        button: baseColors.zooFont,
      },
      withoutBackground: {
        text: baseColors.zooFont,
        button: baseColors.black,
      },
    },
    donate: {
      background: baseColors.tiger,
      text: baseColors.panther,
      link: {
        background: baseColors.honeyBee,
        text: baseColors.panther,
      },
      button: {
        wrapperBackground: baseColors.whipsnadeBg,
        background: baseColors.whipsnadeBg,
        text: baseColors.white,
        activeBackground: baseColors.honeyBee,
        activeText: baseColors.panther,
        hoverText: baseColors.black,
      },
    },
    donateHeaderButton: {
      background: baseColors.tiger,
      text: baseColors.panther,
      activeBackground: baseColors.white,
      activeText: baseColors.panther,
      hoverBackground: baseColors.honeyBee,
      hoverText: baseColors.panther,
      border: baseColors.tiger,
      iconColor: baseColors.panther,
    },
    newsletter: {
      bg: baseColors.redPanda,
    },
    featureBackground: baseColors.redPanda,
    caption: baseColors.zooFont,
    heading: baseColors.zooFont,
    text: baseColors.zooFont,
    tableHeading: baseColors.tiger,
    link: baseColors.redPanda,
    accordionTabColour: baseColors.zooFont,
    accordionIconColour: baseColors.zooFont,
    accordionTabBgr: baseColors.tiger,
    accordionTabBorderColour: baseColors.tiger,
    accordionTabFocusColour: baseColors.honeyBee,
    accordionTabLink: baseColors.redPanda,
    footerBgr: baseColors.redPanda,
    footerNewsletterBlockBtnBgr: baseColors.tiger,
    footerNewsletterBlockBtnBgrHover: baseColors.honeyBee,
    footerNewsletterBlockBtnColor: baseColors.panther,
    footerNewsletterBlockBtnColorHover: baseColors.panther,
    footerNewsletterBlockTextColor: baseColors.zooFont,
    dateUnderlineColor: baseColors.tiger,
    membership: {
      type: {
        goldColor: baseColors.honeyBee,
        silverColor: baseColors.white,
        nameColor: baseColors.black,
        descriptionColor: baseColors.redPanda,
        borderColor: baseColors.tiger,
      },
      price: {
        backgroundColor: baseColors.redPanda,
        pawsIconColor: {
          primary: baseColors.tiger,
          secondary: baseColors.honeyBee,
        },
      },
    },
    eventListing: {
      backgroundColor: baseColors.redPanda,
      textColor: baseColors.white,
    },
  },
  bicentenary: {
    // Todo Bicentenary: For specific component update color as we pick ticket specific to that component.
    primary: baseColors.panther,
    secondary: baseColors.zooBg,
    tertiary: baseColors.gecko,
    eyebrow: baseColors.honeyBee,
    infoLabel: baseColors.honeyBee,
    background: baseColors.whiteLight,
    header: {
      bg: baseColors.panther,
      text: baseColors.white,
      textDesktop: baseColors.white,
      smallNavLink: {
        text: baseColors.gecko,
        textDesktop: baseColors.zooFont,
        bg: baseColors.zooBg,
        bgDesktop: baseColors.gecko78,
      },
    },
    testimonial: {
      title: baseColors.white,
      quote: {
        text: baseColors.black,
        quoteIcon: baseColors.seagrass,
        background: baseColors.honeyBee,
      },
      slider: {
        mainTitleText: baseColors.zooBg,
        paginationBulletActive: baseColors.honeyBee,
        paginationBullet: baseColors.honeyBee,
        paginationArrowCircle: baseColors.honeyBee,
        paginationArrowPath: baseColors.black,
      },
    },
    button: {
      primary: {
        text: baseColors.white,
        bg: baseColors.seagrass,
        border: 'transparent',
        focusBorder: baseColors.gecko78,
        hoverBorder: baseColors.gecko78,
        hoverBackground: baseColors.gecko78,
        hoverText: baseColors.panther,
      },
      secondary: {
        text: baseColors.seagrass,
        bg: baseColors.white,
        border: baseColors.seagrass,
        focusBorder: baseColors.seagrass,
        hoverBorder: baseColors.seagrass,
        hoverBackground: baseColors.white,
        hoverText: baseColors.seagrass,
      },
      download: {
        text: baseColors.seagrass,
        bg: baseColors.white,
        border: baseColors.seagrass,
        focusBorder: baseColors.parakeet,
        icon: baseColors.seagrass,
        file: 'london',
      },
      news: {
        text: baseColors.seagrass,
        bg: baseColors.white,
        border: baseColors.white,
        hoverText: baseColors.panther,
        hoverBackground: baseColors.parakeet,
        focusBorder: baseColors.parakeet,
      },
      pill: {
        text: baseColors.white,
        bg: baseColors.seagrass,
        border: 'transparent',
        focusBorder: baseColors.parakeet,
      },
      social: {
        bg: baseColors.parakeet,
        border: baseColors.parakeet,
        focusBackground: baseColors.white,
        focusBorder: baseColors.seagrass,
      },
      back: {
        text: baseColors.panther,
        bg: baseColors.white,
        border: baseColors.panther,
        focusBorder: baseColors.panther,
        focusBackground: baseColors.white,
      },
    },
    cards: {
      infographic: {
        color: baseColors.honeyBee,
        background: baseColors.seagrass,
      },
      generic: {
        link: baseColors.seagrass,
        eyebrow: baseColors.black,
        paragraph: baseColors.black,
        imageBackground: baseColors.honeyBee,
        label: baseColors.seagrass,
      },
      featureCardTwoThreeSection: {
        background: baseColors.white,
        pattern: baseColors.white,
        primaryButtonBg: baseColors.seagrass,
        primaryButtonText: baseColors.white,
        secondaryButtonHoverBorderColor: baseColors.parakeet,
        primaryButtonHoverBgColor: baseColors.parakeet,
        secondaryButtonBg: baseColors.white,
        secondaryButtonText: baseColors.seagrass,
        mainTitle: baseColors.panther,
        cardTitle: baseColors.panther,
        cardEyebrow: baseColors.parakeet,
        cardParagraph: baseColors.panther,
      },
      event: {
        text: baseColors.black,
        border: baseColors.parakeet,
        background: 'transparent',
        ctaText: baseColors.white,
        ctaBg: baseColors.seagrass,
      },
    },
    carousel: {
      mainTitleText: baseColors.seagrass,
      paginationBulletActive: baseColors.seagrass,
      paginationBullet: baseColors.gecko78,
      paginationOverviewAnchorBg: baseColors.seagrass,
      paginationOverviewAnchorText: baseColors.white,
      paginationArrowCircle: baseColors.seagrass,
      paginationArrowCircleBorder: baseColors.seagrass,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.parakeet,
    },
    imageGalleryPagination: {
      paginationArrowCircle: baseColors.seagrass,
      paginationArrowCircleBorder: baseColors.honeyBee,
      paginationArrowCircleHover: baseColors.white,
      paginationArrowPath: baseColors.honeyBee,
    },
    promo: {
      withBackground: {
        text: baseColors.white,
        button: baseColors.white,
      },
      withoutBackground: {
        text: baseColors.white,
        button: baseColors.honeyBee,
      },
    },
    donate: {
      background: baseColors.seagrass,
      text: baseColors.white,
      link: {
        background: baseColors.parakeet,
        text: baseColors.panther,
      },
      button: {
        wrapperBackground: baseColors.panther,
        background: baseColors.panther,
        text: baseColors.white,
        activeBackground: baseColors.parakeet,
        activeText: baseColors.panther,
        hoverText: baseColors.parakeet,
      },
    },
    donateHeaderButton: {
      background: baseColors.parakeet,
      text: baseColors.panther,
      activeBackground: baseColors.white,
      activeText: baseColors.seagrass,
      hoverBackground: baseColors.gecko78,
      hoverText: baseColors.parakeet,
      border: baseColors.panther,
      iconColor: baseColors.seagrass,
    },
    newsletter: {
      bg: baseColors.seagrass,
    },
    featureBackground: baseColors.seagrass,
    caption: baseColors.white,
    heading: baseColors.black,
    text: baseColors.black,
    tableHeading: baseColors.white,
    link: baseColors.parakeet,
    accordionTabColour: baseColors.white,
    accordionTabColourOpened: baseColors.seagrass,
    accordionIconColour: baseColors.honeyBee,
    accordionTabBgr: baseColors.seagrass,
    accordionTabBorderColour: baseColors.seagrass,
    accordionTabFocusColour: baseColors.seagrass,
    accordionTabLink: baseColors.seagrass,
    footerBgr: baseColors.seagrass,
    footerNewsletterBlockBtnBgr: baseColors.seagrass,
    footerNewsletterBlockBtnBgrHover: baseColors.parakeet,
    footerNewsletterBlockBtnColor: baseColors.white,
    footerNewsletterBlockBtnColorHover: baseColors.black,
    footerNewsletterBlockTextColor: baseColors.seagrass,
    dateUnderlineColor: baseColors.parakeet,
    membership: {
      type: {
        goldColor: baseColors.honeyBee,
        silverColor: baseColors.silver,
        nameColor: baseColors.white,
        descriptionColor: baseColors.honeyBee,
        borderColor: baseColors.parakeet,
      },
      price: {
        backgroundColor: baseColors.seagrass,
        pawsIconColor: {
          primary: baseColors.black,
          secondary: baseColors.white,
        },
      },
    },
    eventListing: {
      backgroundColor: baseColors.whiteLight,
      textColor: baseColors.black,
    },
  },
};
